// store checkbox status when close viewer-modal
export const setViewerModalStatus = ({
  projectID,
  checked,
}: {
  projectID: string;
  checked: boolean;
}): void => {
  // 先讀取現有的 projects_data 設定
  const storedData = localStorage.getItem('projects_data');
  const projectList = storedData ? JSON.parse(storedData) : [];

  // 檢查是否已經存在該 projectID
  const existingIndex = projectList.findIndex(
    (item: { projectID: string }) => item.projectID === projectID,
  );

  if (existingIndex !== -1) {
    // 更新已存在的專案狀態
    projectList[existingIndex].viewerModalChecked = checked;
  } else {
    // 新增新的專案狀態
    projectList.push({ projectID, viewerModalChecked: checked });
  }

  // 儲存回 localStorage
  localStorage.setItem('projects_data', JSON.stringify(projectList));
};

// decide display viewer-modal or not
export const getViewerModalStatus = ({
  projectID,
}: {
  projectID: string;
}): boolean => {
  const storedData = localStorage.getItem('projects_data');
  if (!storedData) return false;

  const projectList = JSON.parse(storedData);
  const project = projectList.find(
    (item: { projectID: string }) => item.projectID === projectID,
  );

  return project ? project.viewerModalChecked : false;
};
